import React, { useState } from 'react'
import { loadStripe } from '@stripe/stripe-js';
import {
    useStripe, useElements, CardElement, Elements, CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
    ElementsConsumer,
} from '@stripe/react-stripe-js';
import { FormattedMessage } from 'react-intl';
import { NotificationManager } from 'react-notifications';
import { CircularProgress } from '@material-ui/core';

const StripeForm = ({ stripe, elements, setToken }) => {
    const [checknum, setChecknum] = useState(false);
    const [checkexp, setCheckexp] = useState(false);
    const [checkcvc, setCheckcvc] = useState(false);
    const [loading,setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!checkcvc || !checknum || !checkexp) {
            setLoading(false)
            return NotificationManager.error(
                <FormattedMessage
                    id="addCorrect"
                    defaultMessage="Please add correct card details"
                />,
                'Error'
            );
           
        }
        if (!stripe || !elements) {
            return
        }
        setLoading(true)
        const cardNumberElement = elements.getElement(CardNumberElement)
        const res = await stripe.createToken(cardNumberElement)
        setToken(res.token.id)
    }

    const handleNumberchange = (e) => {
        if (e.elementType == "cardNumber") {
            if (e.complete == true) {
                setChecknum(true)
            }
        }
        if (e.elementType == "cardExpiry") {
            if (e.complete == true) {
                setCheckexp(true)
            }
        }
        if (e.elementType == "cardCvc") {
            if (e.complete == true) {
                setCheckcvc(true)
            }
        }
    }

    return (
        <form>
            <div>
                <div style={{ marginTop: "10px", border: "1px solid #80808061", borderRadius: "5px", padding: "7px", width: "90%" }}>
                    <CardNumberElement onChange={handleNumberchange} />
                </div>
            </div>
            {/* <div>
            <label htmlFor="cardName">Card Name</label>
            <input
              type="text"
              name="cardName"
              required
              placeholder="Enter Name"
              pattern="[A-Za-z]"
            />
          </div> */}
            <div>
                <div style={{ marginTop: "25px", border: "1px solid #80808061", borderRadius: "5px", padding: "7px", width: "90%" }}>
                    <CardExpiryElement onChange={handleNumberchange} />
                </div>
            </div>
            <div>
                <div style={{ marginTop: "25px", marginBottom: "30px", border: "1px solid #80808061", borderRadius: "5px", padding: "7px", width: "90%" }}>
                    <CardCvcElement onChange={handleNumberchange} />
                </div>
            </div>
        {  loading ? <CircularProgress style={{margin:"0 170px"}} /> :
            
            <button
            className="custom-button"
            onClick={handleSubmit}
        >
            <FormattedMessage id="payment.add" defaultMessage="Add" />
        </button>
        
        }
            
        </form>
    )
}


const CardAdd = ({getToken}) => {
//  console.log('check',test)
    const setToken = (item) => {
        getToken(item)
    }


    return (
        <ElementsConsumer>
            {({ stripe, elements,test }) => (
                <StripeForm stripe={stripe} elements={elements} setToken={setToken} />
            )}
        </ElementsConsumer>

    )
}

export default CardAdd;


// WEBPACK FOOTER //
// ./src/components/Booking/CardAdd.js